import React from 'react';
import './App.css';
import Review from './Review';



function App() {
  
  return (
    <main>
      <section className="container">
        <div className="card border-ligth my-5 shadow">
          <h2 className="card-header display-5 text-center mb-3 ">Our reviews</h2>
        
          <Review />
          
        </div>
      </section>
      <p className="text-center blockquote-footer">By MOHAMMED NAJJAR</p>
    </main>
  );
}

export default App;
